var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.277,
    height: 19.817,
    viewBox: "0 0 19.277 19.817",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun_Edit_Profile_3194834",
    "data-name": "noun_Edit Profile_3194834",
    transform: "translate(-3.8 -2.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_35409",
    "data-name": "Group 35409",
    transform: "translate(3.8 2.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63844",
    "data-name": "Path 63844",
    d: "M13.651,45.1a5.791,5.791,0,0,1-6.387,0A4.012,4.012,0,0,0,3.8,49.086v2.588a.419.419,0,0,0,.417.417h7.764l4.738-4.738A4.07,4.07,0,0,0,13.651,45.1Z",
    transform: "translate(-3.8 -36.209)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    cx: 4.007,
    cy: 4.007,
    r: 4.007,
    transform: "translate(2.671)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63845",
    "data-name": "Path 63845",
    d: "M45.082,82.9a.427.427,0,0,0-.1.188l-.4,2.087a.372.372,0,0,0,.438.438l2.087-.4a.281.281,0,0,0,.188-.1l.4-.4L45.479,82.5Z",
    transform: "translate(-36.066 -65.803)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4065",
    "data-name": "Rectangle 4065",
    width: 6.616,
    height: 3.152,
    transform: "translate(10.425 15.693) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63846",
    "data-name": "Path 63846",
    d: "M83.947,47.51,82.4,45.966a.491.491,0,0,0-.689,0l-.814.814,2.212,2.233.814-.814A.474.474,0,0,0,83.947,47.51Z",
    transform: "translate(-64.808 -36.783)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.caad02da0a698310ec95c03e1732214c.svg";
export { ForwardRef as ReactComponent };